import DetailedCourseContainer from "../../Componant/Learning/DetailedCourse";

const DetailedCourse = () => {
  return (
    <div className="page-body">
      <DetailedCourseContainer />
    </div>
  );
};

export default DetailedCourse;
